import { render, staticRenderFns } from "./supplement.vue?vue&type=template&id=5ed2c723&scoped=true&"
import script from "./supplement.vue?vue&type=script&lang=js&"
export * from "./supplement.vue?vue&type=script&lang=js&"
import style0 from "./supplement.css?vue&type=style&index=0&id=5ed2c723&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed2c723",
  null
  
)

export default component.exports